import classNames from 'classnames';
import { FC } from 'react';

import styles from './Divider.styles.m.css';

export type TDividerTheme =
  | 'style1'
  | 'style2'
  | 'style3'
  | 'style4'
  | 'style5'
  | 'style6'
  | 'style7'
  | 'style8'
  | 'style9';

interface IDividerProps {
  className?: string;
  theme: TDividerTheme;
}

export const Divider: FC<IDividerProps> = (props) => {
  const { theme, className } = props;
  const containerClassName = classNames(styles.container, className, styles[`theme-${theme}`]);
  return <hr className={containerClassName} />;
};
